import React from "react";
import Layout from "./../components/Layout/Layout";
import PageUnderConstruction from "./../components/PageUnderConstruction";

const Contact = () => {
    return (
        <Layout>
            <div>
                <h3>Contact us for more information! </h3>
                  <h3> The paddle challenge is an annual event, sign up if you're interested in participating next yea</h3>
            </div>
            <PageUnderConstruction />
        </Layout>
    )
}

export default Contact